/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Channeltypeevent2Inputs */

const en_channeltypeevent2 = /** @type {(inputs: Channeltypeevent2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event`)
};

const de_channeltypeevent2 = /** @type {(inputs: Channeltypeevent2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event`)
};

/**
* | output |
* | --- |
* | "Event" |
*
* @param {Channeltypeevent2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const channeltypeevent2 = /** @type {((inputs?: Channeltypeevent2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Channeltypeevent2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_channeltypeevent2(inputs)
	return de_channeltypeevent2(inputs)
});
export { channeltypeevent2 as "channelTypeEvent" }